import { AGENT_FILTER_OPERATOR } from 'features/trend-detection/features/agent-create/utils/agent-filter-criteria'
import type {
  AgentFiltersV2,
  FilterCriterion,
} from 'features/trend-detection/types'

/** The `filters_v2` an agent request sends: the form's criteria as a
 * `FilterStateV2`. Every criterion is kept (nothing is filtered against the
 * catalogue), with `AGENT_FILTER_OPERATOR` as its operator — agents are
 * "is"-only. `dateRange` is `null`: an agent's date is chosen per run, and the
 * backend strips a date anyway. */
export function buildAgentFiltersV2(
  criteria: readonly FilterCriterion[],
): AgentFiltersV2 {
  return {
    filters: criteria.map((criterion) => {
      const min = criterion.min != null ? Number(criterion.min) : undefined
      const max = criterion.max != null ? Number(criterion.max) : undefined
      const single = criterion.value == null ? [] : [criterion.value].flat()
      return {
        field: criterion.field,
        operator: AGENT_FILTER_OPERATOR,
        values: criterion.values ?? single,
        ...(min != null && !Number.isNaN(min) ? { min } : {}),
        ...(max != null && !Number.isNaN(max) ? { max } : {}),
      }
    }),
    searchTerms: [],
    searchCriteria: {},
    dateRange: null,
  }
}

/** The two filter groups a benchmarking agent request carries, as v2. Used by
 * create, update, validate-filters and compare-stats so they all send the same
 * shape. */
export function buildBenchmarkingFiltersV2(
  cohortFilters: readonly FilterCriterion[],
  focusGroupFilters: readonly FilterCriterion[],
): {
  cohort_filters_v2: AgentFiltersV2
  focus_group_filters_v2: AgentFiltersV2
} {
  return {
    cohort_filters_v2: buildAgentFiltersV2(cohortFilters),
    focus_group_filters_v2: buildAgentFiltersV2(focusGroupFilters),
  }
}
